import type {
	LabeledValuePayload,
	ModelAssignmentPayload,
} from '@Application/Ai/AiConfiguration/Assignments/Actions/modelAssignmentsFetched';
import LIVE_USAGES from '@Domain/Enums/Ai/LiveUsages';
import UsageSettingsView from '@UI/Store/AiConfiguration/Views/UsageSettingsView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `hasOwnAssignment` says whether this level has its own row; `ownModelId === null` alone does not (a
 * live usage can be switched off at this level, a row without a model). `effectiveModelId === null`
 * means no model resolves at any level — there is no fallback to assume.
 */
class ModelAssignmentView {
	readonly usage: LabeledValuePayload;
	readonly hasOwnAssignment: boolean;
	readonly ownModelId: number | null;
	readonly effectiveModelId: number | null;
	readonly effectiveLevel: LabeledValuePayload | null;
	readonly settings: UsageSettingsView;

	constructor(payload: ModelAssignmentPayload) {
		this.usage = payload.usage;
		this.hasOwnAssignment = payload.hasOwnAssignment;
		this.ownModelId = payload.ownModelId;
		this.effectiveModelId = payload.effectiveModelId;
		this.effectiveLevel = payload.effectiveLevel;
		this.settings = new UsageSettingsView(payload.settings);

		Object.freeze(this);
	}

	get isInherited(): boolean {
		return !this.hasOwnAssignment && this.effectiveModelId !== null;
	}

	get isLive(): boolean {
		return LIVE_USAGES.includes(this.usage.value);
	}

	get isUnconfigured(): boolean {
		return this.effectiveModelId === null;
	}
}

export default ModelAssignmentView;
